import { GridValueFormatterParams } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { DeviceHealth } from 'types';
import { formatDistance } from 'date-fns';

export const timestampToDateFormatter = (
    params: GridValueFormatterParams<number>
) => {
    if (!params.value || params.value === -1) return '';
    return format(new Date(params.value), 'M/d/yyyy h:mm aaa');
};

export const deviceHealthFormatter = (
    params: GridValueFormatterParams<DeviceHealth>
): string => {
    return params.value.tooltip ?? 'Not Configured';
};

export const lastLoginFilter = (
    params: GridValueFormatterParams<string | number>
) => {
    if (!params.value || params.value === -1) return '';
    if (typeof params.value === 'string') params.value = parseInt(params.value);
    return formatDistance(new Date(params.value), new Date(), {
        addSuffix: true,
    });
};
